import { ErrorResult } from '../../../../shared/models/types'
import { BadRequestResponse } from '../../../../types/Errors'
import { deleteAdditionalReference } from '../api/deleteAdditionalReference'

export default function useDeleteAdditionalReferences() {
  const deleteAdditionalReferences = async (ids: number[]) => {
    if (!ids.length) return { errors: [] }

    const settledPromises = await Promise.allSettled(ids.map((id) => deleteAdditionalReference(id)))

    const errors: ErrorResult[] = []
    settledPromises
      .filter((result): result is PromiseRejectedResult => result.status === 'rejected')
      .forEach((result) => {
        const errorResponseData = result.reason?.response?.data
        if (errorResponseData?.message === 'CONSTRAINT_VIOLATION') {
          errorResponseData?.errors.forEach((errorItem: BadRequestResponse) => {
            errors.push({
              message: errorResponseData.message,
              field: errorItem.field,
              code: errorItem.reason,
            })
          })
        }
      })

    return { errors }
  }

  return { deleteAdditionalReferences }
}
